import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-presentacion',
  templateUrl: './presentacion.component.html',
  styleUrls: ['./presentacion.component.scss']
})
export class PresentacionComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }

  ir_servicios(){
    this.router.navigate(['/inicio']);
  }

}
